import { Injectable } from '@angular/core';
import { LocalStorageService } from '@core/auth/services/local-storage/local-storage.service';
import { CodeRequestModel, ResponseModel } from '@core/api';

export interface SessionToken {
  token: string;
  phoneNumber: string;
  countryCode: string;
  time: number
}

@Injectable({
  providedIn: 'root'
})
export class OrderTokenService extends LocalStorageService<SessionToken> {

  constructor () {
    super('CLOSE_ORDER_TOKEN');
  }

  save(phone) {
    return (res: ResponseModel<CodeRequestModel>) => {
      this.value = {
        countryCode: '375',
        phoneNumber: phone,
        token: res.data.request_id,
        time: Date.now()
      };
    }
  }
}
